<section class="sidebar-actions">
  <ng-container *ngIf="isCustomerRole">
    <app-sidebar-create-sr-button class="mb-4"></app-sidebar-create-sr-button>
    <hr class="action-list__divider" />
  </ng-container>

  <ul class="sidebar-actions__action-list action-list">
    <li class="action-list__item" mat-ripple>
      <a class="action-list__item-link" [routerLink]="['/v2/profile']">
        <img src="assets/icons/v2/user-white.svg" alt="">

        <span>View Profile</span>
      </a>
    </li>

    <hr class="action-list__divider" />

    <li class="action-list__item" mat-ripple>
      <button class="action-list__item-link" (click)="signOutClicked.emit()">
        <mat-icon>logout</mat-icon>
        <span>Log Out</span>
      </button>
    </li>
  </ul>
</section>
